var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50344 17V8.28L4.51944 8.808V7.08L7.43144 5.8H8.74344V17H6.50344ZM14.9076 17.192C14.1396 17.192 13.4462 17.0533 12.8276 16.776C12.2089 16.4987 11.7182 16.1093 11.3556 15.608C10.9929 15.1067 10.8116 14.5253 10.8116 13.864C10.8116 13.4053 10.8862 12.9893 11.0356 12.616C11.1956 12.2427 11.4142 11.912 11.6916 11.624C11.9689 11.336 12.2996 11.1173 12.6836 10.968C12.2036 10.744 11.8142 10.424 11.5156 10.008C11.2276 9.592 11.0836 9.12267 11.0836 8.6C11.0836 8.07733 11.2276 7.58667 11.5156 7.128C11.8036 6.66933 12.2302 6.30133 12.7956 6.024C13.3609 5.74667 14.0649 5.608 14.9076 5.608C15.7502 5.608 16.4542 5.74667 17.0196 6.024C17.5849 6.30133 18.0116 6.66933 18.2996 7.128C18.5876 7.58667 18.7316 8.07733 18.7316 8.6C18.7316 9.112 18.5822 9.58133 18.2836 10.008C17.9956 10.424 17.6116 10.744 17.1316 10.968C17.5156 11.128 17.8462 11.352 18.1236 11.64C18.4116 11.9173 18.6302 12.2427 18.7796 12.616C18.9396 12.9893 19.0196 13.4053 19.0196 13.864C19.0196 14.5253 18.8329 15.1067 18.4596 15.608C18.0969 16.1093 17.6062 16.4987 16.9876 16.776C16.3689 17.0533 15.6756 17.192 14.9076 17.192ZM14.9076 15.384C15.5689 15.384 16.0649 15.224 16.3956 14.904C16.7262 14.584 16.8916 14.1787 16.8916 13.688C16.8916 13.144 16.7156 12.7173 16.3636 12.408C16.0222 12.088 15.5369 11.928 14.9076 11.928C14.2889 11.928 13.7982 12.088 13.4356 12.408C13.0836 12.7173 12.9076 13.144 12.9076 13.688C12.9076 14.1787 13.0782 14.584 13.4196 14.904C13.7609 15.224 14.2569 15.384 14.9076 15.384ZM14.9076 10.344C15.4516 10.344 15.8676 10.2053 16.1556 9.928C16.4542 9.65067 16.6036 9.29333 16.6036 8.856C16.6036 8.38667 16.4542 8.024 16.1556 7.768C15.8676 7.50133 15.4516 7.368 14.9076 7.368C14.3742 7.368 13.9582 7.50133 13.6596 7.768C13.3609 8.024 13.2116 8.392 13.2116 8.872C13.2116 9.29867 13.3609 9.65067 13.6596 9.928C13.9582 10.2053 14.3742 10.344 14.9076 10.344Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge18);
export default __webpack_public_path__ + "static/media/age-18.0f478d9954ace5366f5734cb676672f0.svg";
export { ForwardRef as ReactComponent };